module.exports = "<div class=\"scrollContent\">\n    <span class=\"dynAppsLaunchDialog\">\n        <select id=\"stateInput\"></select>\n    </span>\n</div>\n<div data-type=\"horizontal\" data-role=\"controlgroup\">\n    <a id=\"continueButton\" href=\"#\" data-role=\"button\" data-i18n=\"common::continue.title\"></a>\n</div>";


//////////////////
// WEBPACK FOOTER
// /jenkins/workspace/CudaLaunch_release_production/~/html-loader!./dyn_apps/launch_dialog_content.html
// module id = 117
// module chunks = 0